import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, ShieldCheck } from "lucide-react";
import { PHONE, PHONE_HREF, ADDRESS, LOGO_URL, NEIGHBORHOODS } from "@/data/site";
import { WH_SERVICES, PLUMBING_SERVICES } from "@/data/services";

export const Footer = () => (
  <footer className="navy-grain text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <img src={LOGO_URL} alt="Irvine Water Heater Man" className="h-14 w-auto mb-4 bg-white rounded-lg p-1" />
        <p className="text-white/60 text-sm leading-relaxed mb-4">
          Irvine's water heater specialists. Installation, repair, and replacement — tank and tankless, gas and electric — backed by full-service plumbing.
        </p>
        <div className="flex items-center gap-2 text-sm text-white/70 mb-2">
          <ShieldCheck className="w-4 h-4 text-[#FF6500]" /> Licensed &amp; Insured · CA C-36
        </div>
        <div className="flex items-center gap-2 text-sm text-white/70">
          <Clock className="w-4 h-4 text-[#FF6500]" /> Open 24/7 for Emergencies
        </div>
      </div>
      <div>
        <h3 className="font-heading font-bold text-lg mb-4">Water Heater Services</h3>
        <ul className="space-y-2">
          {WH_SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="font-heading font-bold text-lg mb-4">Plumbing &amp; Company</h3>
        <ul className="space-y-2">
          {PLUMBING_SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">
                {s.name}
              </Link>
            </li>
          ))}
          <li><Link to="/about" className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">About Us</Link></li>
          <li><Link to="/service-area" className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">Service Area</Link></li>
          <li><Link to="/reviews" className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">Reviews</Link></li>
          <li><Link to="/contact" className="text-white/60 hover:text-[#FF6500] text-sm transition-colors">Contact</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="font-heading font-bold text-lg mb-4">Get Hot Water Back</h3>
        <a href={PHONE_HREF} data-testid="footer-call-btn" className="inline-flex items-center gap-2 bg-[#FF6500] text-white font-heading font-bold px-6 py-3 rounded-full hover:bg-[#E85C0D] transition-colors mb-4">
          <Phone className="w-4 h-4" /> {PHONE}
        </a>
        <div className="flex items-start gap-2 text-sm text-white/60 mb-4">
          <MapPin className="w-4 h-4 text-[#FF6500] mt-0.5 shrink-0" /> {ADDRESS}
        </div>
        <p className="text-white/40 text-xs leading-relaxed">
          Serving {NEIGHBORHOODS.slice(0, 6).join(", ")} and all of Irvine &amp; Orange County.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 px-4 text-center text-white/40 text-xs">
      © {new Date().getFullYear()} Irvine Water Heater Man. All rights reserved. · Water Heater Repair &amp; Installation in Irvine, CA
    </div>
  </footer>
);
